import React, { Component } from 'react';
import { Button, TextInput} from 'react-responsive-ui';
import PropTypes from 'prop-types';
import { getPostComments, sendCommentForPost, doDeleteComment, doUpdateComment } from '../../helpers/registrationHelper';
import Loading from '../Loading';
import User from '../menu/user';

class Comment extends Component {

    constructor(props) {
        super(props);
        this.props = props
        this.handleCommentUpdate = this.handleCommentUpdate.bind(this)
        this.sendComment = this.sendComment.bind(this)
        this.cancelComment = this.cancelComment.bind(this)
        this.handleEditCommentUpdate = this.handleEditCommentUpdate.bind(this)
        this.handleSendUpdate = this.handleSendUpdate.bind(this)
        // this.test = this.test.bind(this)

        this.state = { isEditing: false, comments: []}
    }

    componentDidMount() {

        getPostComments(this.props.post_id)
        .then((response) => {
            if (!response.data.error) {
                this.setState({ comments: response.data })
            } else {
                console.log('posted message incorrectly')
            }
        })

    }
    render() {
        if (!this.state) {
            return <Loading />
            // return ''
        } else {
            return (
                <div className="comment-list-container">
                    {
                        this.state.comments && this.state.comments.map((item, key) => (
                            <div className="post-wrapper comment" key={key}>
                                <div className="comment-button-wrapper">
                                    {item.user_id == localStorage.getItem('user_id') &&
                                        <button className="edit-button" onClick={() => { this.handleEditComment(item.id) }}>
                                            <img alt="Edit" src={require("../../images/edit-icon.svg")} />
                                        </button>}
                                    { item.user_id == localStorage.getItem('user_id') && 
                                        <button className="delete-button" onClick={() => { this.deleteComment(item.id)} }>
                                            <img alt="Delete" src={require("../../images/delete-icon.svg")} />
                                        </button>}
                                </div>
                                <div className="comment-content">
                                    <User {...this.props} user_id={item.user_id} />
                                    <div className="comment-message">
                                        {this.state.isEditing && this.state.editing_id === item.id ? <div><TextInput
                                            multiline
                                            focus
                                            placeholder="SHARE HOW YOU FEEL TODAY"
                                            value={this.state.edit_comment}
                                            onChange={this.handleEditCommentUpdate} /><Button action={this.handleSendUpdate}>
                                            Update
                                            </Button></div>: item.text}
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                        <div className="post-wrapper new-comment">
                            <div className="comment-wrapper">
                                <User {...this.props} user_id={localStorage.getItem('user_id')}/>
                                <TextInput
                                    multiline
                                    placeholder="Your comment..."
                                    value={this.state.comment}
                                    onChange={this.handleCommentUpdate} />
                            </div>
                            <div className="publish-button">
                                <Button action={this.sendComment}>
                                    Publish
                                </Button>
                            </div>
                            <div className="cancel-button">
                                <Button action={this.cancelComment}>
                                    Cancel
                                </Button>
                            </div>
                        </div>

                </div>
            )
        }
    }
    

    handleEditCommentUpdate(value) {
        this.setState({ edit_comment: value })
    }
    
    handleEditComment(comment_id) {
        let _comment = this.state.comments.filter(function( comment ) {
            return comment.id === comment_id
         });
        this.setState(prevState=> ({ isEditing: !prevState.isEditing, edit_comment: _comment[0].text, editing_id: comment_id}))
    }

    handleCommentUpdate(value) {
        this.setState({ comment: value })
    }

    handleSendUpdate() {
        let editing_id = this.state.editing_id
        let edit_comment = this.state.edit_comment
        let _comments = this.state.comments.filter(function( comment){
            if (comment.id === editing_id) {
                comment.text = edit_comment;
            }
            return comment;
        })
        
        this.setState({isEditing: false, comments: _comments })
        doUpdateComment(this.state.editing_id,edit_comment)
    }

    deleteComment(comment_id) {
        doDeleteComment(comment_id)
            .then((response) => {
                if (response.data.success) {

                    var newComments = this.state.comments.filter(function (comment) {
                        return comment.id !== comment_id
                    });
                    this.setState({ comments: newComments });
                }
            });
    }

    sendComment() {
        sendCommentForPost(this.props.post_id, this.state.comment)
        .then((response) => {
            if (!response.data.error) {
                this.setState(prevState => ({ comment:"", comments: prevState.comments.concat(response.data) }))
            } else {
                console.log('comment posted incorrectly')
            }
        })        
    }

    cancelComment() {
        this.setState({ comment: "" });
    }


}
Comment.propTypes = {
    history: PropTypes.object,
    post_id: PropTypes.number
};

export default Comment;



// WEBPACK FOOTER //
// ./src/components/newsline/comment.js